import { Progress } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { CourseDummy } from 'assets';
import PlayWithoutRing from 'assets/Icons/PlayWithoutRing';
import { motion } from 'framer-motion';
import Image from 'next/image';

import { Course } from '@/components/Courses/CoursesCard';
import encryptToken from '@/components/shared/crypto/encryptToken';

interface CourseCardProps {
  item: Course;
  index: number;
  token: string | null;
}

const CourseContinueReading = ({ item, index, token }: CourseCardProps) => {
  const screens = useBreakpoint();

  const itemAnimation = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.05,
      },
    },
  };

  return (
    <motion.div
      className='w-full max-w-xs overflow-hidden transition-all mr-3 md:mr-4 rounded-lg h-full cursor-pointer duration-300 bg-cartBgColor min-w-[260px] md:min-w-[400px] xl:min-w-[480px]'
      variants={itemAnimation}
      onClick={() => {
        const CRYPTO_KEY = process.env.NEXT_PUBLIC_CRYPTO_KEY || '';
        const encryptedToken = encryptToken(token as string, CRYPTO_KEY);

        const slug = item?.slug;

        const url = `${process.env.NEXT_PUBLIC_COURSE_LIVE}/#/course/${slug}`;

        if (slug) {
          const finalUrl = token
            ? `${url}?redirect_url=${encryptedToken}`
            : url;
          window.open(finalUrl, '_blank');
        }
      }}
    >
      <div className=' rounded-lg overflow-hidden border border-[#282829] h-full'>
        <div className='flex items-center h-full'>
          <div className='py-[18px] px-2 md:px-3 bg-[#121212] '>
            <div className='relative w-[85px] md:w-[140px] lg:w-[160px] aspect-[2/1] overflow-hidden rounded'>
              <Image
                src={item?.course_image_url || CourseDummy}
                alt={item?.name || 'Book cover'}
                fill
                className='object-cover rounded-sm'
              />
            </div>
          </div>

          <div className='flex  px-3 pt-2 md:pt-4 pb-1 md:pb-3 justify-between w-full h-full'>
            <div className='flex flex-col  h-full w-full'>
              <h3 className='text-textLightGray font-light text-[10px] md:text-xs'>
                Zebralearn
              </h3>
              <h2 className='text-white font-semibold max-w-[163px] md:max-w-[200px] lg:max-w-[263px]  text-xs md:text-base truncate'>
                {item?.name}
              </h2>
              <div className='mt-auto'>
                <div className='flex justify-between translate-y-1.5 lg:translate-y-1'>
                  <span className='text-textGrayColor text-[10px] md:text-xs'>
                    {item.completionPercentage}% Completed
                  </span>
                  <span>
                    <PlayWithoutRing width={screens.md ? '24' : '16'} />
                  </span>
                </div>

                <div className='flex flex-col '>
                  <Progress
                    percent={item?.completionPercentage}
                    showInfo={false}
                    className='customProcessBar'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CourseContinueReading;
